import AuthPane from "components/Home/AuthPane";

export interface QuizHeaderProps {
  title: string;
  image: string;
}

const QuizHeader: React.FC<QuizHeaderProps> = ({ title, image }) => {
  return (
    <div className="bg-white py-4 px-8 flex flex-wrap justify-between items-center text-center dark:bg-gray-800">
      <div className="flex flex-row items-center">
        <img className="w-24 mx-auto" src={image} alt={title} />
        <p className="text-lg pr-6 lg:text-xl text-gray-800 font-semibold dark:text-secondary-300">
          {title}
        </p>
      </div>
      <div>
        <AuthPane />
      </div>
    </div>
  );
};

export default QuizHeader;
